// GERADO por `npm run documents:sync`. Não edite: as alterações se perdem.

export const REPORT_TYPES = [
  'aet',
  'apr',
  'aso',
  'esocial_s2210',
  'esocial_s2220',
  'esocial_s2240',
  'lip',
  'lp',
  'ltcat',
  'os',
  'pca',
  'pcmat',
  'pcmso',
  'pcmso_analitico',
  'pgr',
  'plano_acao',
  'plano_acao_cipa',
  'ppp',
  'ppr',
  'quadro_insalubridade',
] as const;

export type ReportType = (typeof REPORT_TYPES)[number];

export const OCC_REPORT_TYPE_LABELS: Record<ReportType, string> = {
  aet: 'AET (Análise Ergonômica do Trabalho)',
  apr: 'APR (Análise Preliminar de Riscos)',
  aso: 'ASO (Atestado de Saúde Ocupacional)',
  esocial_s2210: 'eSocial (S-2210)',
  esocial_s2220: 'eSocial (S-2220)',
  esocial_s2240: 'eSocial (S-2240)',
  lip: 'Laudo de Insalubridade',
  lp: 'LTP (Laudo Técnico de Periculosidade)',
  ltcat: 'LTCAT (Laudo Técnico Previdenciário)',
  os: 'O.S (Ordem de Serviço)',
  pca: 'PCA (Conservação Auditiva)',
  pcmat: 'PCMAT',
  pcmso: 'PCMSO',
  pcmso_analitico: 'Relatório Analítico do PCMSO',
  pgr: 'PGR (Gerenciamento de Riscos)',
  plano_acao: 'Plano de Ação',
  plano_acao_cipa: 'Plano de Ação da CIPA',
  ppp: 'PPP (Perfil Profissiográfico Previdenciário)',
  ppr: 'PPR (Proteção Respiratória)',
  quadro_insalubridade: 'Quadro de insalubridade',
};

export interface ReportGroup {
  label: string;
  types: ReportType[];
}

export const REPORT_GROUPS: ReportGroup[] = [
  {
    label: 'eSocial',
    types: ['esocial_s2210', 'esocial_s2220', 'esocial_s2240'],
  },
  {
    label: 'Laudos',
    types: ['aso', 'lip', 'lp', 'ltcat'],
  },
  {
    label: 'Quadros',
    types: ['quadro_insalubridade'],
  },
  {
    label: 'Programas',
    types: ['pcmso', 'pca', 'ppr', 'pgr', 'aet', 'pcmat', 'os'],
  },
  {
    label: 'Outros',
    types: ['ppp', 'apr', 'plano_acao'],
  },
];
